var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { create } from 'zustand';
var toast = create(function (set) { return ({
    toasts: [],
    addToast: function (text, timeout) {
        if (timeout === void 0) { timeout = 3000; }
        set(function (state) { return ({
            toasts: __spreadArray(__spreadArray([], __read(state.toasts), false), [{ text: text, timeout: timeout }], false),
        }); });
    },
    removeToast: function () {
        set(function (state) { return ({
            toasts: state.toasts.slice(1),
        }); });
    },
    removeAllToast: function () {
        set(function () { return ({
            toasts: [],
        }); });
    },
}); });
export var useToast = toast;
